import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
  NavController,
  NavParams,
  AlertController,
  Platform,
  Events
} from "ionic-angular";
import { Store } from "@ngrx/store";

//import { MarketContract, WatacoinContract } from '../../app/app.contract';
import { ContractsService } from "../../app/app.contract.service";
import { AppState } from "../../app/app.reducer";
import { AppUtilities } from "../../app/app.utilities";
import { NodeService } from "../../services/node.service";
import { Token, Transaction, Wallet } from "../../app/app.models";
import { TokensFetchAction } from "../../app/app.actions";
import { HomePage } from "../home/home";
import { WalletPage } from "../wallet/wallet";

import { ConfigService } from "../../services/config.service";
import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-tokenbuy",
  templateUrl: "tokenbuy.html"
})
export class TokenbuyPage {
  public formData: FormGroup;
  public token$: Token;
  public wallet$: Wallet;

  constructor(
    private contractService: ContractsService,
    public formBuilder: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public nodeService: NodeService,
    public store: Store<AppState>,
    public utilities: AppUtilities,
    private loadingService: WatacardLoadingSerivce,
    private configService: ConfigService,
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    public plt: Platform,
    public events: Events
  ) {
    this.token$ = navParams.data;

    /** this.store.select('wallet').subscribe((wallet: Wallet) => {
      this.wallet$ = wallet;
    }); */

    this.getWallet();

    this.formData = this.formBuilder.group([]);
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad TokenbuyPage");
  }

  cancel() {
    this.navCtrl.pop();
  }

  onSubmit(formData: FormGroup) {
    var idioma = this.configService.getIdiom();
    if (formData.valid && this.token$.next_price <= this.wallet$.watacoins) {
      var tx = this.loadingService.getTempTx();
      console.log("TX" + tx);
      if (tx) {
        console.log("Entrando en el if " + tx);
        this.nodeService
          .getTransactionTemp(tx)
          .then((result: any) => {
            if (result.blockNumber) {
              this.sendNewTransaction(formData);
            } else {
              this.messageAlert();
            }
          })
          .catch(err => {
            this.messageAlert();
          });
      } else {
        console.log("Entrando en el else " + tx);
        this.sendNewTransaction(formData);
      }
    } else {
      var balance = this.translateService.instant("tokenbuy.balance");

      if (
        this.plt.is("core") ||
        this.plt.is("mobileweb") ||
        this.plt.is("cordova")
      ) {
        const prompt = this.alertCtrl.create({
          message: balance,
          buttons: [
            {
              text: this.translateService.instant("CANCELAR"),
              handler: data => {
                console.log("Cancel clicked");
              }
            },
            {
              text: this.translateService.instant("tokenbuy.go_wallet"),
              handler: data => {
                console.log("Saved clicked");
                this.navCtrl.push(WalletPage);
              }
            }
          ]
        });
        prompt.present();
      } else {
        this.utilities.alert(balance);
      }
    }
  }

  sendNewTransaction(formData: any) {
    var idioma = this.configService.getIdiom();
    if (formData.valid && this.token$.next_price <= this.wallet$.watacoins) {
      /** let options = MarketContract.buyAsset.toPayload([this.token$.assetId]);
      // 1eth = 1000000000000000000 Wei
      let transaction: Transaction = {
        from: this.wallet$.address,
        to: MarketContract.address,
        value: this.token$.next_price * 1000000000000000000,
        data: options.data
      };
**/

      let options = this.contractService.WatacoinContract.buyAssetFor.toPayload(
        [this.token$.assetId, this.token$.next_price * 1000000]
      );
      // 1eth = 1000000000000000000 Wei
      let transaction: Transaction = {
        from: this.wallet$.address,
        to: this.contractService.WatacoinContract.address,
        data: options.data
      };
      var purchase_in_process = this.translateService.instant(
        "tokenbuy.purchase_in_process"
      );
      var operation_not_perform = this.translateService.instant(
        "tokenbuy.operation_not_perform"
      );
      var N = 2;
      this.nodeService.sendTransaction(transaction, true).then(
        (tx: any) => {
          if (tx != "error") {
            this.loadingService.setTemp(tx, null, null);
            this.utilities.alert(purchase_in_process);
            //this.navCtrl.setRoot(HomePage);
            this.navCtrl.popTo(
              this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
            );
          } else {
            this.utilities.alert(operation_not_perform);
            //this.navCtrl.setRoot(HomePage);
            this.navCtrl.popTo(
              this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
            );
          }
        },
        error => {
          var message = "Error: replacement transaction underpriced";
          this.utilities.alert(error);
          //this.navCtrl.setRoot(HomePage);
          this.navCtrl.popTo(
            this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
          );
        }
      );
    } else {
      var balance = this.translateService.instant("tokenbuy.balance");
      this.utilities.alert(balance);
    }
  }

  messageAlert() {
    var message_alert = this.translateService.instant("tokenbuy.message_alert");
    this.utilities.alert(message_alert);
  }

  getWallet() {
    this.nodeService
      .getBalanceWatacoins()
      .then(wallet => {
        this.wallet$ = wallet;
        console.log("Watacoins ", wallet);
      })
      .catch(err => {
        console.log("err");
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tokenbuy/tokenbuy.ts